<template>
    <veui-header>
        <div class="home-nav" :class="{'home-nav-scroll': isScrolling}">
            <div class="home-nav-left">
                <div class="cc-header-left" @click="handleBackHome">
                    <img src="../../assets/logo.png" alt="">
                </div>
                <veui-tabs
                    v-if="showTabs"
                    class="home-nav-tab"
                    ui="borderless"
                    :active.sync="activeTab"
                    @change="handleTabChange"
                >
                    <template v-for="item in showNavConfig">
                        <template v-if="!item.authorizedRole || hags[item.authorizedRole]">
                            <veui-tab
                                v-if="item.children"
                                :key="item.value + item.title"
                                :name="item.value"
                                :label="item.title"
                            >
                                <template #item="{label, active}">
                                    <div
                                        :ref="item.value"
                                        :class="{
                                            'nav-item': true,
                                            'nav-item-actived': active,
                                            'nav-custom-item': true,
                                            [`${item.value}-tab-item`]: true,
                                        }"
                                        @mouseenter="handleMouseEnterTab(item)"
                                        @click.stop
                                    >
                                        {{ label }}
                                        <veui-icon
                                            :name="showCustomTabPopover ? 'chevron-up' : 'chevron-down'"
                                            class="nav-custom-arrow"
                                        />
                                    </div>
                                </template>
                            </veui-tab>
                            <veui-tab
                                v-else-if="item.value === 'digitalConsole'"
                                :key="item.value"
                                :label="item.title"
                                :name="item.value"
                            >
                                <template #item="{label, activate, active}">
                                    <div
                                        :ref="item.value"
                                        :class="{
                                            'nav-item': true,
                                            'nav-item-actived': active,
                                            [`${item.value}-tab-item`]: true,
                                        }"
                                        @click="activate"
                                    >
                                        {{ label }}
                                        <span
                                            v-show="!isUC"
                                            class="nav-item-icon-pay"
                                        >定制</span>
                                    </div>
                                </template>

                            </veui-tab>
                            <veui-tab
                                v-else
                                :key="item.value"
                                :label="item.title"
                                :name="item.value"
                            />
                        </template>
                    </template>
                    <!-- 自定义tab-item，避免tabs都不匹配时，第一个tab也会默认选中态 -->
                    <template #tab-item="{label, activate, active, name}">
                        <span
                            :class="{'nav-item': true, 'nav-item-actived': active && activeTab === name}"
                            @click="activate"
                        >{{ label }}</span>
                    </template>
                </veui-tabs>
            </div>
            <div class="home-nav-right">
                <cc-nav-coupon v-if="optName"/>
                <div class="help-icon">
                    <span @click="gotoHelpDoc">
                        <veui-icon ref="helpRef" name="question-circle"/>
                    </span>
                    <veui-tooltip
                        position="bottom"
                        target="helpRef"
                        ui="reverse"
                        :hide-delay="100"
                        overlay-class="help-overlay"
                    >
                        帮助文档
                    </veui-tooltip>
                </div>
                <feedback/>
                <message-center v-if="optName && !hagOnlyDigital"/>
                <avatar v-if="optName"/>
                <div v-if="isStyleV2" class="split-line"></div>
                <div
                    v-if="isStyleV2"
                    class="style-version-toggle"
                >
                    <ai-button
                        class="style-version-toggle-btn"
                        variant="ai"
                        size="small"
                        @click="handleGotoNew('rightBtn')"
                    >体验新版</ai-button>
                </div>
            </div>
        </div>
        <veui-popover
            :open.sync="showCustomTabPopover"
            :target="customTabRef"
            trigger="hover"
            :hide-delay="100"
            overlay-class="custom-popover"
        >
            <div
                v-for="(item, index) in customTabContent"
                :key="`custom-button-${index}`"
                :class="{
                    'custom-tab-button': true,
                    'custom-tab-button-selected': pageRouteName === item.value,
                }"
                @click="handleOpenTabPage(item)"
            >
                {{ item.title }}
            </div>
        </veui-popover>
        <div
            v-if="isStyleV2"
            class="old-header-show-new-tip"
        >
            <veui-icon
                name="exclamation-circle-solid"
                class="icon-yellow"
            />
            为了给您提供更优质的服务，擎舵已完整迁移至新版，2024年12月23日起将默认使用新版本，请及时前往体验。点击
            <veui-button
                ui="text"
                class="old-header-btn-goto-new"
                @click="handleGotoNew('tipLink')"
            >前往新版</veui-button>
        </div>
        <rich-text-dialog
            :open.sync="showNewModal"
            :data="newTipDialogData"
        />
    </veui-header>
</template>

<script>
/* globals ucCommonLogin */
import {Tabs, Tab, Popover, Icon, Header, Tooltip, Button} from 'veui';
import {Button as AiButton} from '@baidu/light-ai-react';
import {applyReactInVue} from 'vuereact-combined';
import {navConfig} from '../config';
import {debounce} from 'lodash';
import {
    getRedirectUrl,
    logoutUcAndPass,
    checkItemValid,
    getRouteQuery
} from '@/common/util';
import store from '@/store';
import {sendAlsLog} from '@/lib/als.js';
import Feedback from '@/component/Feedback';
import RichTextDialog from '@/component/MessageDialog/RichTextDialog';
import MessageCenter from '@/views/Message/MessageCenter';
import NavCoupon from '@/component/Coupon/NavCoupon';
import Avatar from '@/layouts/Avatar.vue';
import 'veui-theme-dls-icons/user-circle';
import 'veui-theme-dls-icons/chevron-up';
import 'veui-theme-dls-icons/chevron-down';
import 'veui-theme-dls-icons/sign-out';
import 'veui-theme-dls-icons/order';
import 'veui-theme-dls-icons/question-circle';
import 'veui-theme-dls-icons/info-circle';
import 'veui-theme-dls-icons/link-alt-solid';
import 'veui-theme-dls-icons/exclamation-circle-solid';

import {oldToNewTipDialogData} from '../config/configV2';

export default {
    name: 'nav-component',
    components: {
        'veui-tabs': Tabs,
        'veui-tab': Tab,
        'veui-popover': Popover,
        'veui-button': Button,
        'veui-icon': Icon,
        'veui-header': Header,
        'veui-tooltip': Tooltip,
        'ai-button': applyReactInVue(AiButton),
        Feedback,
        MessageCenter,
        RichTextDialog,
        'cc-nav-coupon': NavCoupon,
        Avatar
    },
    inject: ['$toast', '$alert'],
    data() {
        return {
            navConfig,
            copyright: '您所提交的内容应合法合规，且不得侵犯百度或第三人合法权益。您在本平台生成的内容仅限于百度推广平台内推广设置时使用。',
            activeTab: this.$route.matched[0].name || '',
            isScrolling: false,
            customTabRef: '',
            showCustomTabPopover: false,
            customTabContent: [],
            // 是否显示新版提醒的弹窗
            showNewModal: false,
            newTipDialogData: oldToNewTipDialogData,
            pageRouteName: this.$route.matched[1]?.name || this.$route.matched[0].name || ''
        };
    },
    computed: {
        debouncedScrollHander() {
            return debounce(this.handleScroll, 10);
        },
        optName() {
            return store.state.app.userInfo.accountInfo?.optName || '';
        },
        userName() {
            return store.state.app.userInfo.accountInfo?.userName || '';
        },
        isStyleV2() {
            return this.$store.state.app.userInfo.isStyleV2;
        },
        noBackground() {
            // 帮助文档页面为白色背景
            return this.$route.name === 'helpDoc';
        },
        showTabs() {
            // 帮助文档页面不展示导航菜单
            return !(this.$route.name === 'helpDoc');
        },
        showFooter() {
            const showRouteList = ['textCreateWork', 'imageCreateWork', 'userCenter'];
            return showRouteList.indexOf(this.$route.matched[0].name) >= 0;
        },
        hags() {
            return store.state.app.userInfo.bizHags;
        },
        userInfo() {
            return store.state.app.userInfo;
        },
        isUC() {
            return store.state.app.userInfo.isUC;
        },
        hagOnlyDigital() {
            return this.hags.digital_is_passport;
        },
        showNavConfig() {
            const {navConfig, checkTabVisible} = this;
            return navConfig.filter(checkTabVisible).map(item => {
                if (item.children) {
                    return {
                        ...item,
                        children: item.children.filter(checkTabVisible)
                    };
                }
                return item;
            });
        },
        curCoupon() {
            return store.state.app.couponInfo?.availablePoints || 0;
        }
    },
    watch: {
        // 从数字人导航里的口播侧导跳到脚本文案页面，顶部应该切换active项
        $route(newVal, oldVal) {
            if (this.showTabs) {
                this.activeTab = this.$route.matched[0].name || '';
                this.pageRouteName = this.$route.matched[1]?.name || this.$route.matched[0].name || '';
            }
        }
    },
    methods: {
        // 判断某个导航选项是否能显示
        checkTabVisible(item) {
            const {hags, userInfo} = this;
            return checkItemValid(item, {hags, userInfo});
        },
        // 点击前往新版，清除缓存
        handleGotoNew(type) {
            this.alsLog({
                f1: 'oldHeaderGotoNew',
                f2: 'click',
                f11: type
            });
            window.sessionStorage.removeItem('style_click_old');
            this.$router.push({
                name: 'homeV2Default'
            });
        },
        handleBackHome() {
            this.$router.push({
                query: getRouteQuery() || {},
                name: 'home'
            });
        },
        handleTabChange(tab) {
            if (!this.userName) {
                this.login();
                return false;
            }
            this.$router.push({
                query: getRouteQuery() || {},
                name: tab.name
            });
        },
        handleScroll() {
            this.isScrolling = !!document.documentElement.scrollTop > 0;
        },
        login() {
            if (this.isPassport) {
                setTimeout(() => {
                    ucCommonLogin.show();
                }, 500);
                return;
            }
            window.location.href = getRedirectUrl(window.location.pathname);
            // window.location.href = '/index';
        },
        logoutClick() {
            // 退出，回到首页，如果pass，则回到passport首页
            let pathname = '/index';
            // if (this.isPassport) {
            //     pathname += '?type=passport';
            // }
            logoutUcAndPass(pathname);
        },
        handleMouseEnterTab(item) {
            this.customTabRef = this.$refs[item.value];
            this.customTabContent = item.children;
            this.showCustomTabPopover = true;
        },
        handleOpenTabPage(item) {
            this.activeTab = item.value;
            this.$router.push({
                name: item.value
            });
        },
        gotoHelpDoc() {
            const {protocol, host} = window.location;
            const prefix = `${protocol}//${host}`;
            const firstDoc = '信息流广告标题';
            const url = `${prefix}/helpDoc/${firstDoc}`;
            this.alsLog({
                f1: 'helpDoc',
                f2: 'click',
                f5: this.$route.name,
                f15: this.$route?.path
            });
            window.open(url, '_blank', 'noreferrer');
        },
        alsLog(data) {
            const userid = this.$store.state.app.hairuo?.userid;
            const optid = this.$store.state.app.hairuo?.optid;
            if (!userid) {
                return false;
            }
            // 如果没有f5，默认把页面路径带上
            if (data.f5 == null) {
                data.f5 = this.$route.name;
            }
            return sendAlsLog({
                ...data,
                f3: userid,
                f14: optid
            });
        }
    },
    mounted() {
        window.addEventListener('scroll', this.debouncedScrollHander);

        this.$nextTick(() => {
            if (this.isStyleV2) {
                this.showNewModal = true;
            }
        });
    },
    destroyed() {
        window.removeEventListener('scroll', this.debouncedScrollHander);
    }
};
</script>

<style lang="less" scoped>
@content-padding: 24px;
.basic-container {
    // background: url(https://qiaojiang.bj.bcebos.com/fe/qingduoBannerBg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-image: linear-gradient(-140.34deg, #C5D6FE 3.07%, #E6F2FF 45.99%, rgba(214, 221, 255, 0.6) 113.46%);
    width: 100%;
    height: 100vh;
    min-width: min(100%, fit-content);
    overflow: auto;

    // 帮助文档页，背景为白色
    &-no-bg {
        background-image: none !important;
        background-color: #FFF;
        .home-nav {
            background: #FFF;
            /* 阴影AI/S1 */
            box-shadow:
                0px 2px 8px 0px rgba(0, 71, 194, 0.01),
                0px 3px 9px 0px rgba(0, 71, 194, 0.02),
                0px 4px 10px 0px rgba(0, 71, 194, 0.03);
        }
        /deep/ .veui-layout-content{
            margin: @headerHeightNoBg 0 0 @content-padding !important;
            height: calc(100vh - @headerHeightNoBg - @footer-height);
            overflow: auto;
        }
        /deep/ .veui-layout-header {
            height: @headerHeightNoBg !important;
        }

    }
    /deep/ .veui-layout-header {
        box-shadow: none;
        background: transparent;
        height: @header-height;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
    }

    /deep/ .veui-layout-footer {
        padding: 12px 0;
        height: @footer-height;
        .copyright {
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            color: @dls-color-gray-7;
        }
    }

    // todo: content部分白底样式统一class类名，后续根据其他页面设计稿再优化结构
    /deep/ .veui-layout-content {
        margin: @header-height @content-padding 0;
        height: calc(100vh - @header-height - @footer-height);
    }
}

.home-nav {
    position: fixed;
    width: 100%;
    height: 64px;
    top: 0;
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: transparent;
    &-left {
        display: flex;
    }
    .cc-header-left {
        display: flex;
        align-items: center;
        margin-right: 48px;
        cursor: pointer;
        img {
            height: 24px;
        }
    }
    /deep/ .veui-tabs-menu {
        height: 42px;
    }
    &-tab {
        display: inline-block;
        padding-top: 22px;
        .nav-item {
            line-height: 20px;
            cursor: pointer;
            position: relative;
            &-actived {
                color: #3A5BFD;
                font-weight: 500;
                &:after {
                    content: '';
                    display: block;
                    width: 14px;
                    height: 1px;
                    background-color: #3A5BFD;
                    width: 28px;
                    height: 3px;
                    position: absolute;
                    top: 100%;
                    left: 50%;
                    transform: translate(-50%, -3px);
                    border-radius: 4px;
                }
            }
            &-icon-pay{
                width: 28px;
                height: 14px;
                position: absolute;
                top: -10px;
                font-size: 10px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                border-radius: 4px 4px 4px 0;
                background: var(--AI, linear-gradient(269deg, #9D6DFF 0.05%, #5F82FF 48.58%, #67A4FF 99.95%));
                filter:
                    drop-shadow(0px 2px 24px rgba(0, 84, 230, 0.02))
                    drop-shadow(0px 4px 26px rgba(0, 84, 230, 0.03))
                    drop-shadow(0px 6px 28px rgba(0, 84, 230, 0.04));
            }
        }
    }
    &-right {
        display: flex;
        align-items: center;
        gap: 16px;

        .split-line {
            width: 1px;
            height: 16px;
            background: @dls-color-gray-5;
        }
        .style-version-toggle {
            /deep/ .light-ai-button {
                height: 32px;
                border-radius: 48px;
                font-size: 14px;
                &-ai-icons {
                    display: none;
                }
                &:hover {
                    &::before,
                    &::after {
                        opacity: 0.2;
                    }
                }
            }
        }
    }
    .nav-custom-item {
        cursor: pointer;
        &:hover {
            color: #3A5BFD;
        }
        .nav-custom-arrow {
            // position: absolute;
            // right: -16px;
        }
        &.assetsLibraryPictrue-tab-item {
            // width: 66px;
            // position: relative;
            // margin-left: -6px;
        }
    }
}
.home-nav-tab {
    /deep/.veui-tabs-item > .veui-tabs-item-label {
        align-items: flex-start;
    }
    /deep/.veui-tabs-item-label-content {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
    }
    /deep/.veui-tabs-item:not(.veui-disabled) > .veui-tabs-item-label::after {
        left: 50%;
        width: 28px;
        height: 3px;
        border-radius: 4px;
        transform: translateX(-50%);
    }
    /deep/.veui-tabs-item-active:not(.veui-disabled) > .veui-tabs-item-label::after {
        background-color: #3A5BFD;
    }
    /deep/.veui-tabs-item:not(.veui-disabled):hover > .veui-tabs-item-label {
        color: #3A5BFD;
    }
    /deep/.veui-tabs-item-active:not(.veui-disabled) > .veui-tabs-item-label {
        color: #3A5BFD;
        font-weight: 500;
    }
    /deep/.veui-tabs-item-label-ellipsis  {
        overflow: visible;
    }
}
// 临时Bug处理：只有一个导航、出现了左右箭头且超出hidden，需要显示定制角标，临时覆盖样式
/deep/ .home-nav-tab.veui-tabs-overflow {
    .veui-tabs-list {
        overflow: visible;
    }
    .veui-tabs-menu {
        .veui-tabs-prev,
        .veui-tabs-next {
            display: none;
        }
    }
}
.custom-tab-button {
    cursor: pointer;
    width: 70px;
    line-height: 26px;
    text-align: center;
    &:hover {
        color: #3A5BFD;
    }
    &-selected {
        color: #3A5BFD;
    }
}
.custom-popover {
    margin-top: -22px;
}
.help-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    cursor: pointer;
    &:hover {
        color: #545B66;
    }
}
.help-overlay {
    /deep/ .veui-tooltip {
        border-radius: var(--Radius-r1, 6px);
        background: var(----G9, #282C33);
        margin-top: 6px;
        padding: 0 8px;
        height: 25px;
    }
    /deep/ .veui-tooltip-content {
        margin: 0px;
        color: var(----G0, #FFF);
        display: inline-flex;
        height: 100%;
        align-items: center;
    }
    /deep/ .veui-tooltip-arrow {
        color: var(----G9, #282C33);
    }
}

// 旧版头部显示跳转新版的提示
.old-header-show-new-tip {
    position: fixed;
    top: 76px;
    height: 36px;
    left: 24px;
    right: 24px;
    background: rgba(255, 248, 235, 1);
    font-size: 14px;
    line-height: 20px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    border-radius: 6px;
    color: rgba(13, 15, 18, 0.95);
    .icon-yellow {
        color: rgba(254, 168, 0, 1);
        vertical-align: -1px;
        margin-right: 8px;
    }
    .old-header-btn-goto-new {
        color: rgba(58, 91, 253, 1);
        margin-left: 4px;
    }
}
</style>

<style lang="less">
.message-rich-text-dialog.old-header-newtip-messageDialog {
    .custom-dialog-header-bg {
        display: none;
    }
    .custom-dialog-header-text {
        font-family: FZPinShangHeiS-B-GB;
        font-size: 30px;
        font-weight: 400;
        line-height: 33.98px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: rgba(25, 27, 30, 1);
    }
    .veui-ai-dialog-content {
        background-image: url(https://now.bdstatic.com/stash/v1/9f89a08/aigc-fe/ee00117/old-message-box-bg.png?x-bce-process=image/resize,p_10),
            url(https://now.bdstatic.com/stash/v1/9f89a08/aigc-fe/ee00117/old-message-box-bg.png);
        background-repeat: no-repeat, no-repeat;
        background-size: 604px 358px, 604px 358px;
        background-position: -5px -5px, -5px -5px;
        height: 380px;
        width: 600px;
        background-color: #fff;
        border: 2px solid rgba(255, 255, 255, 1);
        box-shadow: 0px 8px 16px 4px rgba(0, 71, 194, 0.08),
            0px 7px 14px 2px rgba(0, 71, 194, 0.07),
            0px 1px 8px 0px rgba(0, 71, 194, 0.05);
    }
    .veui-ai-dialog-content-foot {
        padding-bottom: 36px;
    }
}
.header-v1-tip-messageDialog-content {
    height: 294px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 12px;
    white-space: normal;
    word-break: break-all;
    padding: 36px 32px 0;
    text-align: left;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 500;
    line-height: 26px;
    text-align: left;
    h5 {
        height: 34px;
        margin-bottom: 12px;
    }
    span {
        white-space: normal;
        text-align: left;
        font-family: PingFang SC;
        font-size: 14px;
        line-height: 26px;
        word-break: break-all;
    }
    .red-font {
        color: rgba(245, 63, 63, 1);
    }
}
</style>